<template>
  <div class="container">
    <caregiver-form
        @submit="editCaregiver"
        @cancel="cancelEditCaregiver"
        v-loading.fullscreen.lock="fullscreenLoading"
        :caregiver="caregiver"
    />
  </div>
</template>

<style lang="scss" scoped>
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
</style>

<script>
import CaregiverForm from './CaregiverForm'
import CaregiverModel from '../../model/CaregiverModel'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'CaregiverEdit',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      caregiver: {},
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getCaregiver()
  },
  components: {
    CaregiverForm,
  },
  methods: {
    async getCaregiver () {
      try {
        this.fullscreenLoading = true
        let raw = await this.$api.Caregiver.get(this.id)
        this.caregiver = CaregiverModel.fromJSON(raw)
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    async cancelEditCaregiver (id) {
      try {
        await this.$confirm('คุณต้องการยกเลิกการเปลี่ยนแปลงข้อมูล ?', '', {
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่',
          type: 'warning',
        })
        this.$router.push({ name: 'CaregiverDetail', params: { id }, query: { tab: 'caregiverinfoTab' } })
      } catch (error) {}
    },
    async editCaregiver (caregiver) {
      try {
        this.fullscreenLoading = true
        await this.$api.Caregiver.update(caregiver)
        this.showSuccessDialog({ name: 'CaregiverDetail', params: { id: caregiver.id }, query: { tab: 'caregiverinfoTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
  },
}
</script>
